import { Form, Input } from "decorator-form";

import InputType from "common/form/InputType";
import { registerWidget } from "common/form/register";
import ButtonSelect from "common/form/widgets/common/ButtonSelect";

const iconTypeWidget = registerWidget(ButtonSelect.withOptions([
	{value: 'bp', label: 'Blueprint', default: true},
	{value: 'external', label: 'External'},
]), "string");

const iconPositionWidget = registerWidget(ButtonSelect.withOptions([
	{value: 'left', label: 'Left', default: true},
	{value: 'right', label: 'Right'},
]), "string");

@Form({title: "Icon View Config"})
export default class IconViewConfig {

	@Input({type: InputType.UNIT, title: "Icon Margin"})
	public iconMargin: string;

	@Input({type: iconTypeWidget, title: "Icon Type"})
	public type: "bp" | "external";

	@Input({type: iconPositionWidget, title: "Icon Position"})
	public iconPosition: "left" | "right";

	@Input({type: InputType.COLOR, title: "Icon Color"})
	public color: string;

	@Input({type: InputType.NUMBER, title: "Icon Size"})
	public iconSize: number = 16;

}



// WEBPACK FOOTER //
// ./src/common/views/icon/IconConfig.ts